import OverviewLayout from "./OverviewLayout";
import OverviewHeader from "./header/OverviewHeader";
import StrategiesList from "./portfolios/StrategiesList";
import {
  useStrategies,
  type BasePortfolioType,
  type PortfolioType,
} from "@repo/api";

interface OverviewProps {
  className?: string;
}

const Overview = ({ className = "" }: OverviewProps) => {
  const { data, isLoading, error } = useStrategies();
  const strategyMap = (data || []).reduce((acc, strategy) => {
    return { ...acc, [strategy.modelId]: strategy };
  }, {} as Record<string, BasePortfolioType>);
  const portfolios = (data || [])
    .map((s) => ({
      ...s,
      draft: strategyMap[`${s.modelId}_draft`] as BasePortfolioType | undefined,
    }))
    .filter((s) => !s.modelId.endsWith("draft")) as PortfolioType[];

  // Handle error state
  if (error) {
    return (
      <div
        className={`min-h-full flex items-center justify-center ${className}`}
      >
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">⚠️</div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Error Loading Strategies
          </h2>
          <p className="text-gray-600 mb-4">
            {error?.message || "An error occurred while loading strategies"}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <OverviewLayout portfolios={portfolios || []} className={className}>
      {/* Page Header */}
      <OverviewHeader className="mb-6" />

      {/* Strategies List */}
      {portfolios && (
        <StrategiesList portfolios={portfolios} isLoading={isLoading} />
      )}
    </OverviewLayout>
  );
};

export default Overview;
